import React from 'react';
import Modal from 'react-bootstrap/Modal'
import {useDispatch, useSelector} from "react-redux";
import {deleteMaterialImport, setDeleteMaterialImport} from "../../actions/supplier";
import {getParams} from "../../utils/hooks/getParams";

const MaterialImportDeleteForm = ({supplier_id}) => {


    const dispatch = useDispatch();

    const {delete_material_import} = useSelector(state => state.supplier);

    const closeModal = () => {
        dispatch(setDeleteMaterialImport(null))
    };

    const onConfirm = () => {
        const params = getParams();
        params.supplier_id = supplier_id;
        dispatch(deleteMaterialImport(delete_material_import.id, params));
    };

    let condition = false;
    if (delete_material_import !== null && delete_material_import !== undefined)
        condition = true;

    return (
        <div>
            <Modal show={condition} onHide={closeModal}>
                <Modal.Header className="bg-danger" closeButton>
                    <Modal.Title className="text-white">Yetkazib berishni o'chirish</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Siz haqiqatdan ham ushbu material import ni bekor qilmoqchimisiz?
                </Modal.Body>
                <Modal.Footer>
                    <button onClick={closeModal} className="btn btn-secondary">YO'Q</button>
                    <button onClick={onConfirm} className="btn btn-primary">HA</button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default MaterialImportDeleteForm;